export default "__VITE_ASSET__ma8jsM9u__"